import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#4D4E58", fillRule: "evenodd", d: "M7.533 7.633a.625.625 0 0 1 .884 0l3.558 3.558 3.558-3.558a.625.625 0 0 1 .884.884l-3.559 3.558 3.559 3.558a.625.625 0 0 1-.884.884l-3.558-3.558-3.558 3.558a.625.625 0 0 1-.884-.884l3.558-3.558-3.558-3.558a.625.625 0 0 1 0-.884Z", clipRule: "evenodd" }));
export {
  t as default
};
